import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const useUpdateUserLocationChat = () => {
    const { enabled } = useAppSelector(prop('chatWidget'));

    return useCallback(() => {
        if (!enabled) {
            return;
        }

        window.Communication?.API?.chat?.updateUserLocation?.();
    }, [enabled]);
};
